export default __webpack_public_path__ + "static/media/element_35.99954e18.webp";